import styled from "styled-components";
import { setFlex, setPosition } from "../variables/utils";
import { BREAKPOINTS } from "../variables/breakpoints";

export const Wrapper = styled.div`
  ${setPosition({ position: "relative" })};
  width: 100%;
`;

export const Container = styled.div`
  ${setFlex({ justify: "center", align: "center", direction: "column" })};
  width: 100%;
`;

export const Headline = styled.h1`
  ${setPosition({ position: "absolute", top: "0" })};
  ${setFlex({ justify: "center", align: "center", direction: "column" })};
  height: 100vh;
  font-family: univers-roman;
`;

export const Paragraph = styled.p`
  font-family: univers-light;
`;

export const VideoContainer = styled.div`
  ${setPosition({ position: "relative" })};
  width: 100%;
  height: 100%;
`;

export const VideoControls = styled.div`
  ${setPosition({ position: "absolute", bottom: 70, left: "0", zIndex: 1 })};
  @media (max-width: ${BREAKPOINTS.md}px) {
    bottom: unset;
    top: ${props => (props.$isHSApp ? "50px" : "0")};
  }
  cursor: pointer;
`;

export const SVGWrapper = styled.div`
  width: auto;
  padding: 0.5rem;
  pointer-events: none;
`;
